import React, { createContext, useMemo, useReducer } from 'react';
import PropTypes from 'prop-types';
import widgetReducer from 'src/reducers/widgetReducer';

const initialState = {
  showLauncher: true,
  showMenu: false,
  showWidget: false
};
const WidgetContext = createContext(initialState);

export const WidgetProvider = (props) => {
  const { children } = props;
  const [state, dispatch] = useReducer(widgetReducer, initialState);
  const value = useMemo(() => {
    return { state, dispatch };
  }, [state]);

  return (
    <WidgetContext.Provider value={value} {...props}>
      {children}
    </WidgetContext.Provider>
  );
};

WidgetProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default WidgetContext;
